export const liveAPIPath = 'https://api.cellcash.net/';
// export const liveAPIPath = 'https://uat-api.cellcash.net/';
export const localAPIPath = 'http://localhost:3007/';

export const brandImagePath = liveAPIPath + 'assets/brands/';
export const modelImagePath = liveAPIPath + 'assets/models/';